import { jsx as _jsx } from "react/jsx-runtime";
import "../scss/Backdrop.scss";
var Backdrop = function (_a) {
    var callback = _a.callback, _b = _a.cssClasses, cssClasses = _b === void 0 ? "" : _b, _c = _a.isTransparent, isTransparent = _c === void 0 ? false : _c;
    return (_jsx("div", { className: "Backdrop  ".concat(cssClasses + (isTransparent ? "isTransparent" : "")), onClick: function () { return callback(); }, "aria-hidden": "true" }));
};
export default Backdrop;
